module.exports = __webpack_public_path__ + "static/hygiene-mobile-71443473825d1265333c9525d8873187.svg";